import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';

import { dashboardV2Client } from '../api/client';
import { dashboardLiveQueryOptions } from '../api/liveQuery';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { DashboardAlertsData } from '../api/types';

// The Take Over toast feed (GRAVY-10443), on the dashboard's existing 30-second
// poll — the admin app has no push channel.
//
// The cursor is held in a ref and advanced by each response, not placed in the
// query key: a key that changed every poll would mint a new cache slot every 30
// seconds. The first request carries no cursor, so the server answers with only
// the current one and an opened dashboard never replays earlier alerts.
const useDashboardAlerts = (agencyId: number | null) => {
  const cursor = useRef<number | null>(null);

  return useQuery<DashboardAlertsData>({
    queryKey: dashboardV2QueryKeys.alerts(agencyId ?? 0),
    queryFn: async () => {
      const data = await dashboardV2Client.getAlerts(
        agencyId as number,
        cursor.current,
      );
      cursor.current = data.cursor;
      return data;
    },
    enabled: agencyId != null,
    ...dashboardLiveQueryOptions,
  });
};

export default useDashboardAlerts;
